import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from '../../shared/components/header/header.component';
import { ProviderSidebarComponent } from '../sidebar/provider-sidebar.component';
import { PageHeaderComponent } from '../../shared/components/page-header/page-header.component';
import { ActivitiesComponent } from '../../shared/components/activities/activities.component';

@Component({
  selector: 'app-provider-activities',
  standalone: true,
  imports: [
    CommonModule,
    HeaderComponent,
    ProviderSidebarComponent,
    PageHeaderComponent,
    ActivitiesComponent
  ],
  templateUrl: './activities.component.html',
  styleUrl: './activities.component.scss',
})
export class ProviderActivitiesComponent {
}
